import type { ReactNode } from 'react';
import { ChartBar, Shield, Users } from '@phosphor-icons/react';

/** Ruban des couleurs d'univers produits, comme en haut de la barre latérale. */
const RUBAN = ['bg-sante-vivid', 'bg-emprunteur-vivid', 'bg-auto-vivid', 'bg-moto-vivid', 'bg-habitation-vivid', 'bg-animal-vivid', 'bg-prevoyance-vivid'];

const ATOUTS = [
  { icon: Users, titre: 'Gestion clients', texte: 'CRM intégré avec suivi des contacts et tâches', fond: 'bg-habitation-tint text-habitation-deep' },
  { icon: Shield, titre: 'Souscription pour compte client', texte: 'Tarification et signature depuis le backoffice', fond: 'bg-auto-tint text-auto-deep' },
  { icon: ChartBar, titre: 'Tableau de bord', texte: 'Suivi des performances et commissions', fond: 'bg-animal-tint text-animal-deep' },
];

/**
 * Cadre des écrans hors connexion (connexion, invitation) : panneau marine de la direction
 * « Univers » à gauche, formulaire sur fond froid à droite. Sur mobile, le panneau se réduit
 * au ruban et au logo.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-svh flex flex-col lg:flex-row bg-ground">
      <aside className="lg:w-[44%] bg-ink text-white flex flex-col">
        <div className="flex h-1.5 shrink-0" aria-hidden="true">
          {RUBAN.map((c) => (
            <div key={c} className={`flex-1 ${c}`} />
          ))}
        </div>
        <div className="flex-1 flex flex-col justify-center px-6 py-6 sm:px-10 lg:px-16 xl:px-20">
          <img src="/images/logo-finance-blanc.png" alt="Finance For You" className="h-7 lg:h-8 w-auto self-start" />
          <div className="hidden lg:block mt-14">
            <p className="font-display text-[44px] font-extrabold leading-[1.04] tracking-[-0.03em]">Votre espace collaborateur</p>
            <p className="mt-4 max-w-md text-lg leading-relaxed text-[#B9C6D6]">
              Gérez vos clients, devis, contrats et souscriptions en toute simplicité.
            </p>
            <ul className="mt-10 space-y-4">
              {ATOUTS.map(({ icon: Icon, titre, texte, fond }) => (
                <li key={titre} className="flex items-center gap-4">
                  <span className={`size-10 shrink-0 rounded-goutte-sm flex items-center justify-center ${fond}`}>
                    <Icon className="size-5" aria-hidden="true" />
                  </span>
                  <span>
                    <span className="block text-sm font-semibold">{titre}</span>
                    <span className="block text-xs text-[#8FA3BC]">{texte}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <p className="hidden lg:block px-16 xl:px-20 pb-8 text-xs text-[#8FA3BC]">Finance For You &amp; Assurances · Espace collaborateur</p>
      </aside>
      <main className="flex-1 flex flex-col justify-center px-6 py-10 sm:px-10 lg:px-16">
        <div className="w-full max-w-md mx-auto">{children}</div>
        <p className="lg:hidden mt-10 text-center text-xs text-ink-muted">Finance For You &amp; Assurances · Espace collaborateur</p>
      </main>
    </div>
  );
}
